export enum Emissor {
  VRPAT = 'VRPAT',
  JVCEF = 'JVCEF',
  VRGPA = 'VRGPA',
  PATCEF = 'PATCEF',
}

export enum Portal {
  EC = 'EC',
  RH = 'RH',
  CN = 'CN',
  BEN = 'BEN',
  GPA = 'GPA',
}
